import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Radio, Spin, Button} from "antd";
import {CreditCardIcon, SavingsIcon} from "../../../common/icons";
import ZuoraHostedPage from "./ZuoraHostedPage";
import SlimpayIframe from "./SlimpayIframe";
import {api} from "../../../services";
import InfoCircleOutlined from "@ant-design/icons/lib/icons/InfoCircleOutlined";

@inject('commonStore', 'connectionRequestsStore', 'translationsStore')
@observer
export default class PaymentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      defaultPaymentMethod: undefined,
      selectedPaymentMethod: undefined,
      paymentMethods: []
    };
  }

  componentDidMount() {
    api('getZuoraPaymentMethods', this.props.customerDetails.uuid)
      .then(result =>
        this.setState({
          paymentMethods: result.records,
          defaultPaymentMethod: result.defaultPaymentMethod,
          selectedPaymentMethod: result.defaultPaymentMethod ? result.records.find(pm => pm.Id === result.defaultPaymentMethod) : undefined,
          loading: false
        })
      )
  }

  onPaymentMethodChange = e => {
    const selectedPaymentMethod = e.target.value;
    this.setState({ selectedPaymentMethod });
  };

  onConfirm = () => {
    this.setState(
      { loading: true },
      async () => {
        await api('setPaymentMethodDefault', this.props.customerDetails.zuora_account_id, this.state.selectedPaymentMethod.Id, this.state.selectedPaymentMethod.Type);

        if (this.props.connections) {

          await this.props.connectionRequestsStore.subscribeToProducts(this.props.customerDetails.uuid, this.props.connections);
        }

        this.props.onNext();
      }
    );
  }

  render() {
    const { translationsStore } = this.props;
    const isOnlyAddingPaymentMethod = !this.props.connections;
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px'
    };

    if(this.state.loading) {
      return <Spin />
    }

    return (
      <div className={'PaymentPage'}>
        <h3>{translationsStore.translate('connectionRequests.checkout.payment.title')}</h3>
        <div className="CheckoutContainer">
          <Radio.Group onChange={this.onPaymentMethodChange} value={this.state.selectedPaymentMethod}>
            {
              this.state.paymentMethods
                .map(paymentMethod =>
                  paymentMethod.Type === 'BankTransfer'
                  ? <Radio style={radioStyle} value={paymentMethod} key={paymentMethod.Id}>
                      <SavingsIcon />{' '}
                      {translationsStore.translate('connectionRequests.checkout.payment.sepa')}{' '}
                      {paymentMethod.BankTransferAccountNumberMask} {paymentMethod.Id === this.state.defaultPaymentMethod && '(default)'}
                    </Radio>
                  : <Radio style={radioStyle} value={paymentMethod} key={paymentMethod.Id}>
                      <CreditCardIcon />{' '}
                      {translationsStore.translate('connectionRequests.checkout.payment.card')}{' '}
                      {paymentMethod.CreditCardMaskNumber} {paymentMethod.Id === this.state.defaultPaymentMethod && <span className="defaultPayment">(default)</span>}
                    </Radio>
                )
            }
            {this.state.paymentMethods.length > 0 && <h4>{translationsStore.translate('connectionRequests.checkout.payment.addPayment')}</h4>}
            <Radio style={radioStyle} value={'creditcard'}>
              <CreditCardIcon /> {translationsStore.translate('connectionRequests.checkout.payment.card')}
            </Radio>
            <Radio style={radioStyle} value={'sepa'}>
              <SavingsIcon /> {translationsStore.translate('connectionRequests.checkout.payment.sepa')}
            </Radio>
          </Radio.Group>
          {this.state.paymentMethods.length > 0 &&
            <div className="PaymentInfo">
              <InfoCircleOutlined />
              <div>{translationsStore.translate('connectionRequests.checkout.payment.info')}</div>
            </div>
          }
        </div>

        {
          this.state.selectedPaymentMethod === 'creditcard'
            ? <ZuoraHostedPage
                connections={this.props.connections}
                customerDetails={this.props.customerDetails}
                onNext={this.props.onNext}
              />
            : this.state.selectedPaymentMethod === 'sepa'
              ? <SlimpayIframe
                  connections={this.props.connections}
                  customerDetails={this.props.customerDetails}
                  onNext={this.props.onNext}
                />
              : <div style={{textAlign: 'center', marginTop: '15px'}}>
                  <Button
                    style={{width: 'auto'}}
                    type="primary"
                    disabled={!this.state.selectedPaymentMethod}
                    onClick={() => this.onConfirm()}
                  >
                    {translationsStore.translate(isOnlyAddingPaymentMethod ? 'paymentManagement.paymentMethodPopup.addPaymentMethod' : 'connectionRequests.checkout.payment.confirm')}
                  </Button>
                </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/PaymentPage/PaymentPage.js